import { Component,OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as Aos from 'aos';
@Component({
  selector: 'app-outBound',
  templateUrl: './outBound.component.html',
  styleUrls: ['./outBound.component.scss']
})
export class OutBoundComponent implements OnInit{
   
  constructor(
    private titleService: Title,
    private router : Router
  )
  {    }

  ngOnInit(){
    this.titleService.setTitle('Out-Bound');
    
    setTimeout(() => {
      Aos.init();
    }, 500);       
      Aos.refresh();
  }

  goPlaces() {
    this.router.navigate(['/']);
  }
}
